export default {
    //search-company
    people: "인물",
    clearAll: "모두 지우기",
    searchProspects: "검색...",
    //actions
    isFoundIn: "에 저장됨",
    isNotFoundWithinAnyLists: "어떤 목록에서도 찾을 수 없음",
    l: "개 목록",
    remove: "제거",
    saveToLists: "목록에 저장",
    DeleteFailed: "삭제 실패",
    //delete dialog
    areYouSureYouWantToDeleteThisRecord:
      "이 기록을 삭제하시겠습니까?",
    proceedingWithDeletionWillResultInPermanentRemovalOfTheList:
      "삭제를 진행하면 해당 목록이 영구적으로 제거됩니다",
    byCancelingYouEnsureThatNoListsWillBeRemoved:
      "취소하면 어떤 목록도 제거되지 않습니다",
    //export dialog
    holdOnWereGeneratingYourExport: "잠시만요, 내보내기를 생성 중입니다",
    UseThisButtonOnlyIfYouWishToCancelYourAction:
      "이 버튼은 작업을 취소하려는 경우에만 사용하세요",
    //save search pop
    saveSearch: "검색 저장",
    newSaveSearch: "새 검색 저장",
    UpdateSavedSearch: "저장된 검색 업데이트",
    enterNewSearchName: "새 검색 이름 입력",
    visibility: "공개 여부",
    manageWhoCanSeeYourSavedSearch: "저장된 검색을 볼 수 있는 사람 관리",
    private: "비공개",
    onlyYouCanSeeYourSavedSearch: "나만 저장된 검색을 볼 수 있습니다",
    everyoneCanSeeYourSavedSearch: "모든 사람이 저장된 검색을 볼 수 있습니다",
    pinSavedSearch: "저장된 검색 고정",
    findSavedSearch: "저장된 검색 찾기",
    enterSavedSearchName: "저장된 검색 이름 입력",
    duplicate: "복제",
    update: "업데이트",
    enterATitleForYourCard: "카드에 대한 제목 입력",
    enterYourCardNumber: "카드 번호 입력",
    digit: "3자리 숫자",
    provideYourCompleteAddress: "전체 주소 제공",
    selectYourCountry: "국가 선택",
    //add credits pop
    ClickTheButtonBelowToAddMoreCredits:
      "아래 버튼을 클릭하여 더 많은 크레딧을 추가하세요!",
    PleaseEnterTheAmountYouLikeToTopUpToYourCredit:
      "크레딧을 충전하고 싶은 금액을 입력하세요",
    //companyLink\contactBtn\functionBtn\default
    more: "더 보기",
    verified: "확인됨",
    GetEmailSuccessfully: "이메일 성공적으로 가져옴",
    CopySuccessfully: "성공적으로 복사됨",
    recorded: "기록됨",
    implement: "구현",
    sequence: "시퀀스",
    of: "의",
    toAssistYouEffectivelyWeRequireFurtherDetailsAbout:
      "효과적으로 도움을 드리기 위해 검색 기본 설정에 대한 추가 세부 정보가 필요합니다. 왼쪽 패널의 필터 옵션을 활용하여 원하는 기준을 지정하면 검색 결과를 세분화하고 요구 사항에 맞는 타겟 개인을 제공할 수 있습니다.",
  
    //filter
    all: "모두",
    my: "내 것",
    team: "팀",
    lists: "저장된 목록",
    employees: "직원",
    technologies: "기술",
    socialmedia: "소셜 미디어",
    enterSocialMedia: "소셜 미디어 입력",
    noResultsFound: "결과를 찾을 수 없음",
    searchCompanies: "회사 검색",
    filters: "필터",
    enterCompanies: "회사 입력",
    accountHqLocation: "계정 본사 위치",
    CityStateCountryZIP: "도시/주/국가/우편번호",
    enterLocations: "위치 입력",
    revenue: "수익",
    chooseARangeOfRevenue: "수익 범위 선택",
    ofRevenueIsUnknown: "의 수익은 알 수 없음",
    technology: "기술",
    category: "카테고리",
    categories: "카테고리",
    enterCategories: "카테고리 입력",
    enterTechnologies: "기술 입력",
    enterIndustries: "산업 입력",
    employee: "직원",
    predefinedRange: "미리 정의된 범위",
    ofEmployeesIsUnknown: "의 직원은 알 수 없음",
    enterNames: "이름 입력",
    jobTitle: "직책",
    searchForAJobTitle: "직책 검색",
    founded: "설립",
    chooseARangeOfFoundedTime: "설립 기간 선택",
    from: "부터",
    to: "까지",
    specialties: "전문 분야",
    enterSpecialties: "전문 분야 입력",
    location: "위치",
    excludedLocationsLabel: '위치 [제외]',
    location_exclude: "[제외]",
    total: "총",
    department: "부서",
    EnterDepartments: "부서 입력",
    JobTitle: "직책",
    EnterJobTitles: "직책 입력",
    ManagementLevel: "관리 레벨",
    EnterManagementLevels: "관리 레벨 입력",
    AccountHQ: "계정 본사",
    ContactHQ: "연락처 본사",
    departmentFunction: "부서 기능",
    EnterJobFunctions: "직무 입력",
    enterNamesAndPressTheEnterKey: "이름을 입력하고 Enter 키를 누르세요...",
    EnterJobTitlesAndPressTheEnterLKey:
      "직책을 입력하고 Enter 키를 누르세요...",
    filterInclude: "포함",
    filterSelectAll: "모두 선택",
    filterDeselectAll: "선택 해제",
    filterRegionOther: "기타",
    filterRegionAsiaPacific: "아시아 태평양",
    filterRegionSouthAsia: "남아시아",
    filterRegionCentralAsia: "중앙아시아",
    filterRegionMiddleEast: "중동",
    filterRegionEurope: "유럽",
    filterRegionAfrica: "아프리카",
    filterRegionAmerica: "아메리카",
    contactDetails: "연락처 정보",
    filterMustContain: "다음을 포함",
    filterWorkEmail: "회사 이메일",
    filterPersonalEmail: "개인 이메일",
    filterPhone: "전화번호",
    filterHasEmail: "이메일 있음",
    filterHasPhone: "전화번호 있음",
    filterExcludeWithoutContact: "연락처 정보가 없는 연락처 제외",
    pleaseSelectRange: "범위를 선택하세요",
    exclude_locations: "위치 제외",
    filterExclude: "제외",
  
    //table
    selectAllCompanies: "모든 회사 선택",
    selected: "선택됨",
    export: "내보내기",
    industry: "산업",
    keywords: "키워드",
    companyLocation: "회사 위치",
    action: "작업",
    contact: "연락처",
    Title: "직책",
    clearSelection: "선택 해제",
    selectNumberOfCompanies: "회사 수 선택",
    maxCompanies: "최대 회사 수",
    youCanOnlySelectAMaximumOf25Companies:
      "최대 25개의 회사만 선택할 수 있습니다.",
    UpgradeYourPlanNow: "지금 플랜을 업그레이드하세요!",
    viewPlans: "플랜 보기",
    applySelection: "선택 적용",
    selectNumberOfProspects: "잠재 고객 수 선택",
    maxProspects: "최대 잠재 고객 수",
    maxProspectsPerCompany: "회사당 최대 잠재 고객 수",
    youCanOnlySelectAMaximumOf25Prospects:
      "최대 25명의 잠재 고객만 선택할 수 있습니다.",
    PleaseSelectTheDataToBeExported: "내보낼 데이터를 선택하세요",
    overview: "개요",
    genericContacts: "일반 연락처",
    size: "규모",
    contactLocation: "연락처 위치",
    pleaseSelectItems: "항목을 선택하세요",
    specialties: "전문 분야",
    moreSpecialty: "+{count}개 더보기",


    // 新UI
    prospectsSearch: "잠재 고객 검색",
    companiesSearch: "회사 검색",
    savedSearches: "저장된 검색",
    savedLists: "저장된 목록",


    // saved list and saved searches
    sortAndFilter: "정렬 및 필터",
    sortBy: "정렬 기준",
    filterAll: '모두',
    filterPrivate: '비공개',
    filterTeam: '팀',
    searchSavedLists: "저장된 목록 검색",
    savedSearchName: "저장된 검색 이름",
    noFilteringOptionsAvailable: "필터링 옵션을 사용할 수 없습니다.",
    manageWhoCanSeeThisSearch: "이 검색을 볼 수 있는 사람 관리",
    noSavedSearchesMatchYourQuery: "쿼리와 일치하는 저장된 검색이 없습니다. 다른 키워드를 사용하거나 철자를 확인하세요.",
    onlyU: "나만",
    anyoneOnTheTeam: "팀의 모든 사람",
    createNewList: "새 목록 만들기",
    groupTeam: "팀",
    groupPersonal: "개인",
    manageWhoCanViewThisList: "이 목록을 볼 수 있는 사람 관리",
    enterAListName: "목록 이름 입력",
    savedList: "저장된 목록",
    listName: "목록 이름",
    saveContactsTo: "연락처 저장 위치",
    contactEmails: "연락처 이메일",
    contactPhones: '연락처 전화번호',
    unlockContactDetails: "연락처 세부 정보 잠금 해제",
    getContactInfo: '연락처 정보 가져오기',
    contactDetailsAreOnTheWay: "연락처 세부 정보가 곧 도착합니다",
    noDataAvailable: '사용 가능한 데이터 없음',
    accessEmails: "이메일 액세스",
    accessPhoneNumber: "전화번호 액세스",
    accessPhoneNumbersAndEmails: "전화번호 및 이메일 액세스",

    redemptionComplete: "사용 완료!",
    bulkRedeemProcessing: "대량 사용 처리 중...",
    notifyMeWhenCompleted: "완료 시 알림",
    expectedTime: "예상 시간:",
    redeemSeconds: "{count}초",
    redeemLoading: "로딩 중...",
    estimatedCharge: "예상 비용: {count} 크레딧",


    estimatedCost: "예상 비용: {count} 크레딧",
    finalChargeBasedOnRequest: "최종 요금은 요청의 성공적인 완료 여부에 따라 달라질 수 있습니다",
    showLess: "간단히 보기",
    exportLeadsToCSV: "리드를 CSV로 내보내기",
    exportComplete: "내보내기 완료!",
    exporting: "내보내는 중...",
    pleaseSelectTheFieldsThatNeedToBeExported: "내보낼 필드를 선택하세요",
    exportLeads: "선택한 {count}개의 리드를 내보내려고 합니다. 선택 크기에 따라 몇 분 정도 소요될 수 있습니다. | 선택한 {count}개의 리드를 내보내려고 합니다. 선택 크기에 따라 몇 분 정도 소요될 수 있습니다.",
    dataFieldsToInclude: "포함할 데이터 필드",
    savedListRecords: '{count}개 기록',
    deleteList: "목록 삭제",
    actionCannotBeUndone: "이 목록을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
    selectedContactsNumber: "{count}개의 선택된 연락처",
    btnSave: "저장",
    btnUnsave: "저장 해제",
    specialties: "전문 분야",
    upgradeNowToAccessMore: "지금 업그레이드하여 더 많은 기능에 액세스하세요!",
    selectCompanyNumber: "현재 플랜으로는 최대 {count}개의 회사까지 선택할 수 있습니다. | 현재 플랜으로는 최대 {count}개의 회사까지 선택할 수 있습니다.",
    selectPeopleNumber: "현재 플랜으로는 최대 {count}명의 잠재 고객까지 선택할 수 있습니다. | 현재 플랜으로는 최대 {count}명의 잠재 고객까지 선택할 수 있습니다.",
    selectAll: "모두",
    selectThisPage: '이 페이지',
    selectCustomize: '맞춤 설정',
    pleaseSelectTheFilteringType: "필터링 유형을 선택하세요",
    theQuantityCannotBeZero: '수량은 0일 수 없습니다',
    filterSearch: "필터 검색",
    view: "보기",
    deleteSavedSearch: "저장된 검색 삭제",
    deleteThisSavedSearch: "이 저장된 검색을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
    createASequenceToStartAutomatingYourOutreach: "아웃리치 자동화를 시작하려면 시퀀스를 만들고 준비되면 여기에 항목을 추가하세요.",
    unsaveThemFromHere: "선택한 잠재 고객이 이미 저장된 경우, 여기에서 저장을 취소할 수 있습니다.",
    createAListToSaveAndOrganizeProspects: "잠재 고객을 저장하고 정리할 목록을 만드세요",
    savedFilters: "저장된 필터",
    viewResults: "검색 결과 보기",

    // search empty
    resultNoResultsFound: "결과를 찾을 수 없음",
    noContactsThatMatchYourSearch: "검색 또는 필터와 일치하는 항목이 없습니다.<br />필터를 변경하거나 다른 키워드를 사용해 보세요.",
    requestTimedOut: "요청 시간 초과",
    theServerIsCurrentlyBusy: "서버가 현재 사용 중이어서 결과를 로드할 수 없습니다.<br />페이지를 새로 고쳐보세요.",
    btnRefresh: "새로고침",

    // tooltip
    tooltipRedeemEmail: "이메일 사용",
    tooltipRedeemPhone: "전화번호 사용",
    tooltipRedeemEmailAndPhone: "모두 사용",
    tooltipSearchPeople: "선택한 회사에서 사람 찾기",
    tooltipFilter: "필터",
    tooltipSequence: "워크플로",
    tooltipSave: "목록에 저장",
    textFindPeople: "사람 찾기",

    // recent mode
    recentMode: "최근 모드",
    tryRealTimeAgain: "실시간 다시 시도",
    realTimeResultsAreTemporarilyPaused: 'API 제한으로 인해 실시간 결과가 일시적으로 중단되었습니다',

    // company-detail
    companies: "회사",

    // recent search
    popularUseCases: "인기 있는 사용 사례",
    skipTheGuesswork: "추측은 건너뛰고, 인기 있는 필터 조합부터 시작하세요.",
    labelRecentSearches: "최근 검색",
    labelRecentSavedFilters: "최근 저장된 필터",
    useThisFilterSetup: "이 필터 설정을 사용합니다",
    startByApplyingFilters: "왼쪽 패널에서 필터를 적용하여 관련 연락처와 회사를 찾아보세요.",


    // 
    k: 'k',

  filterAdvertisementStartDateSubTitle: "광고 시작일 기간",
  filterAdvertisementEndDateSubTitle: "광고 종료일 기간",
  filterAdvertisementSearchTermsSubTitle: "광고 검색어",
  filterAdvertisementExcludeTargetLocation: "대상 위치 제외",
  active_filters_count: "활성 필터 1개 | 활성 필터 {count}개",
  company_list: "회사 목록",
  filter_presets: "필터 프리셋",
  my_list: "내 목록",
  company_profile: "회사 프로필",
  people_workforce: "인력 및 근무 현황",
  technology_presence: "기술 및 현황",
  saved_searches_count: "{count}개 저장됨",
  filterJobExcludeLocation: "제외할 직무 지역",

  enter_keywords: "키워드 입력",
  filter_keywords_description_search_title: "설명 내 검색",
  filter_keywords_description_search_tooltip: "회사 설명 내에서 키워드를 검색합니다.",
  filter_places_description_search_title: "특정 장소 제외",
  filter_places_description_search_tooltip: "검색 결과에서 특정 장소를 제외합니다.",
  enter_places: "장소 입력",
  enterAdvertisementSearchTerms: "검색어를 입력하고 Enter 키를 누르세요...",
  people_list: "인재 목록",
  clear: "지우기",
  places: "장소",

  expand_filters: "필터 열기",
  collapse_filters: "필터 닫기",
};
